<template>
    <div style="padding-top:30px;">
      <a v-if="deal_id" :href="'/account/users/general-partners/' + this.deal_id + '/sales-pipeline'" class="btn btn-info btn-sm" style="margin-top:-30px;margin-bottom:10px;background:#20365F;">Back to the Pipeline</a>
      <div v-if="!is_loaded">
        The data is loading ...
      </div>
      <div v-else>
          <div class="pta-investor-profile-head">
            <h1>{{ investor.name }}<br />Investor Profile</h1>
            <img src="/images/logo_profile.svg" />
            <ul class="mm-links">
              <li><a :href="'/ip/'+id+'/pdf'" class="mm-link-pdf">PDF</a></li>
              <!-- <li><a :href="'/fs/'+id+'/doc'" class="mm-link-word">Word</a></li>
               <li><a target="_blank" :href="'/fs/'+user.alias+'/share'" class="mm-link-share">Share</a></li> -->
            </ul>
          </div>
          <div class="pta-investor-profile">
            <div class="pta-investor-profile-left">
              <h2>GENERAL INFORMATION</h2>
              <div class="pta-investor-profile-box">
                  <h3>DESCRIPTION</h3>
                  <div class="pta-investor-profile-box-content" v-html="investor.description?investor.description:'No information available.'"></div>
              </div>
              <div class="pta-investor-profile-box-2">
                <h3>INVESTOR TYPES</h3>
                <div class="pta-investor-profile-box-content" v-if="investor.investor_types.length">
                  <span v-for="investor_type in investor.investor_types">{{ investor_type }}</span>
                </div>
                <div class="pta-investor-profile-box-content" v-else>
                  No information available.
                </div>
              </div>
              <div class="pta-investor-profile-box-2 pta-ml-40">
                <h3>ACTIVE</h3>
                <div class="pta-investor-profile-box-content">
                  {{ investor.active?investor.active:'No information available.' }}
                </div>
              </div>
              <div class="pta-clear-left"></div>
              <h2>CONTACT INFORMATION</h2>
              <div class="pta-investor-profile-box-2">
                <h3>PRIMARY CONTACT</h3>
                <div class="pta-investor-profile-box-content" v-if="investor.contact_person">
                      {{ investor.contact_person }}<br />
                      {{ investor.cp_email }}<br />
                       {{ investor.website }}
                </div>
                <div v-else class="pta-investor-profile-box-content">
                  No information available.
                </div>
              </div>
              <div class="pta-investor-profile-box-2 pta-ml-40">
                <h3>PRIMARY OFFICE</h3>
                <div class="pta-investor-profile-box-content" v-if="investor.hq_country || investor.hq_city || investor.hq_global_sub_region || investor.hq_global_region">
                  <div v-html="investor.hq_city?investor.hq_city:''"></div>
                  <div v-html="investor.hq_country?investor.hq_country :''"></div>
                  <div v-html="investor.hq_global_sub_region?investor.hq_global_sub_region:''"></div>
                  <div v-html="investor.hq_global_region?investor.hq_global_region:''"></div>
                </div>
                <div class="pta-investor-profile-box-content" v-else>
                  No information available.
                </div>
              </div>
            </div>
            <div class="pta-investor-profile-right">
              <h2>INVESTMENT PREFERENCES</h2>
              <div class="pta-investor-profile-box">
                <h3>POLICY DESCRIPTION</h3>
                <div class="pta-investor-profile-box-content" v-html="investor.policy_description?investor.policy_description:'No information available.'"></div>
              </div>
              <div class="pta-investor-profile-box-2">
                <h3>PREFERRED COMMITMENT SIZE (USD MM)</h3>
                <div class="pta-investor-profile-box-content">
                  {{ investor.preferred_commitment_size?investor.preferred_commitment_size:'No information available.' }}
                </div>
              </div>
              <div class="pta-investor-profile-box-2 pta-ml-40">
                <h3>ASSETS UNDER MANAGEMENT (USD MM)</h3>
                <div class="pta-investor-profile-box-content">
                  {{ investor.assets_under_management?investor.assets_under_management:'No information available.' }}
                </div>
              </div>
              <div class="pta-investor-profile-box-2 pta-clear-left">
                <h3>GEOGRAPHICAL PREFERENCES</h3>
                <div class="pta-investor-profile-box-content" v-if="investor.geos.length">
                  <span v-for="geo in investor.geos">{{ geo }}</span>
                </div>
                <div class="pta-investor-profile-box-content" v-else>
                  No information available.
                </div>
              </div>
              <div class="pta-investor-profile-box-2 pta-ml-40">
                <h3>PREFERRED ASSET CLASSES</h3>
                <div class="pta-investor-profile-box-content" v-if="investor.asset_classes.length">
                 <span v-for="asset_class in investor.asset_classes">{{ asset_class }}</span>
                </div>
                <div class="pta-investor-profile-box-content" v-else>
                  No information available.
                </div>
              </div>
              <div class="pta-investor-profile-box-2 pta-clear-left">
                <h3>ESG STATUS</h3>
                <div class="pta-investor-profile-box-content">
                  {{ investor.esg_status?investor.esg_status:'No information available.' }}
                </div>
              </div>
              <div class="pta-investor-profile-box-2 pta-ml-40">
                <h3>INVESTMENT STRUCTURE</h3>
                <div class="pta-investor-profile-box-content">
                  {{ investor.investment_structure?investor.investment_structure:'No information available.' }}
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>
<script>
    export default {
        components : {  },
        data() {
            return {
              id:this.$route.params.id,
              deal_id:this.$route.params.deal_id,
              is_loaded: false,
              investor:''
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/investors');
            }
            this.fetchUserData();
        },
        methods: {
          fetchUserData(){
            axios.get('/api/investor/'+this.id)
                .then(response => response.data)
                .then(response => {
                  this.investor = response.investor;
                  this.is_loaded = true;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/account/investors');
                })
          },
        },

      filters: {
        moment(date) {
          return helper.formatDate(date);
        },
        momentDateTime(date) {
          return helper.formatDateTime(date).replace(" "," at ");
        }
      }
    }
</script>
<style>
.pta-investor-profile-head{
  background:#162a58 url(/images/background_profile.png) no-repeat;
  background-size: cover;
  color:#fff;
  padding:80px 30px 40px;
  -webkit-border-top-left-radius: 20px;
  -webkit-border-top-right-radius: 20px;
  -moz-border-radius-topleft: 20px;
  -moz-border-radius-topright: 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  position: relative;
}
.pta-investor-profile-head img{
  position: absolute;
  width:200px;
  height:auto;
  right:40px;
  bottom:30px;
}
.pta-investor-profile-head ul.mm-links{
  float:none;
  position: absolute;
  right:40px;
  top:30px;
  margin:0;
}
.pta-investor-profile-head h1{
  margin-bottom:0;
  color:#ffffff;
  font-weight:500;
  font-size:40px;
}
.pta-clear-left{
  clear: left;
}
.pta-investor-profile:after{
  content:'';
  display:table;
  clear: both;
}
.pta-clear-after:after{
  content:'';
  clear: both;
  display:table;
}
.pta-investor-profile h2{
  background: rgb(234, 242, 250);
  padding:10px 20px 10px 30px;
  border-top:1px solid #162a58;
  margin-top:40px;
  font-size:20px;
}
.pta-investor-profile-right,
.pta-investor-profile-left{
  width:50%;
  float:left;
}
.pta-investor-profile-right{
  padding-left:25px;
}
.pta-investor-profile-left{
  padding-right:25px;
}
.pta-investor-profile-box{
  margin-bottom: 30px;
  border-radius: 10px;
}
.pta-investor-profile-box-2 h3,
.pta-investor-profile-box h3{
  padding:10px 20px 10px 30px;
  font-weight:500;
  margin:0;
  font-size:15px;
}
.pta-investor-profile-box-2{
  float:left;
  width:calc(50% - 20px);
}
.pta-investor-profile-box-2.pta-ml-40{
  margin-left:40px;
}
.pta-investor-profile-box-content{
  padding: 20px 30px;
  font-size:15px;
  background:#f0f0f1;
  border-top:1px solid #162a58;
}
.pta-investor-profile-box-content span:after{
  content: ', '
}
.pta-investor-profile-box-content span:last-child:after{
  content: ''
}
.pta-investor-profile-box-content ul{
  margin-left:24px;
  margin-bottom:0;
  padding-left:0;
}
.pta-investor-profile-box-content ul li{
  margin-bottom:5px;
}
.pta-investor-profile-box-content ul li:last-child{
  margin-bottom:0px;
}
.pta-investor-profile-box-content table tr td{
  padding:10px 0;
  border-bottom:1px solid #efefef;
  vertical-align: top;
}
.pta-investor-profile-box-content table tr td:first-child{
  padding-right:20px;
}
.pta-investor-profile-box-content table tr:last-child td{
  border-bottom:0px solid #efefef;
}
.pta-investor-profile-box-content-list span:after{
  content:', ';
}
.pta-investor-profile-box-content-list span:last-child:after{
  content:'';
}
</style>